<script setup lang="ts">
import type { ScanErrorEntry } from '@/lib/usePolledScan'
import { UNTESTED_TONE } from '@/lib/tone'
import ToneChip from './ToneChip.vue'

const props = defineProps<{
  errors: readonly ScanErrorEntry[]
  describe?: (checkId: string) => string | undefined
}>()
</script>

<template>
  <section
    v-if="props.errors.length > 0"
    id="checks-that-could-not-run"
    class="scroll-mt-24"
  >
    <h2 class="text-balance text-xl font-semibold text-ink">
      Checks that could not run
    </h2>
    <p class="max-w-prose text-sm text-ink-muted">
      These checks produced no verdict at all, so whatever they would have tested is untested.
      This is not the same as a check that ran and found nothing wrong.
    </p>

    <ul class="mt-4 flex flex-col gap-3">
      <li
        v-for="error in props.errors"
        :key="error.checkId"
        class="card flex overflow-hidden"
        data-tone="untested"
      >
        <div
          class="tone-stripe w-[3px] shrink-0"
          aria-hidden="true"
        />
        <div class="flex min-w-0 flex-1 flex-col gap-2 p-4">
          <ToneChip
            :tone="UNTESTED_TONE.tone"
            :glyph="UNTESTED_TONE.glyph"
            :label="UNTESTED_TONE.label"
          />
          <span class="quoted break-all">{{ error.checkId }}</span>
          <p
            v-if="props.describe?.(error.checkId)"
            class="text-sm text-ink-muted"
          >
            {{ props.describe(error.checkId) }}
          </p>
          <p class="break-words text-ink">
            {{ error.message }}
          </p>
        </div>
      </li>
    </ul>
  </section>
</template>
